import { Translate } from 'next-translate'

import { linkBuilder } from '@/components/Link/linkBuilder'
import { CateCity } from '@/context/Cities'
import { Zone } from '@/types/cities'
import provinceUtils from '@/utils/cities/province-utils'

interface Breadcrumb {
  readonly href?: string
  readonly isLast: boolean
  readonly isLink: boolean
  readonly label: string
  readonly showOnMobile: boolean
}

export default function getListingsBreadcrumbs(
  t: Translate,
  lang: Locale,
  hasProperty: boolean,
  cities: CateCity[],
  area?: CateCity,
  city?: CateCity,
  zone?: Zone
): Breadcrumb[] {
  const isProvince = provinceUtils.citySupportsProvince(area?.name, cities)
  const breadcrumbs: Breadcrumb[] = []

  // Add area
  if (isProvince) {
    const newBreadcrumb: Breadcrumb = {
      href: linkBuilder.listingByArea.url(lang, cities, area?.slug),
      isLast: Boolean(!city && !zone),
      isLink: Boolean(area && city),
      label: t('common:province-of', { area: area?.translatedCityName }),
      showOnMobile: Boolean(hasProperty || typeof zone === 'undefined'),
    }

    breadcrumbs.push(newBreadcrumb)
  }

  // Add city
  if (typeof city !== 'undefined') {
    const newBreadcrumb: Breadcrumb = {
      href: linkBuilder.listingByCity.url(lang, cities, city.slug),
      isLast: Boolean(!zone && !hasProperty),
      isLink: Boolean(zone || (hasProperty && city.city_zones?.length === 0)),
      label: city.translatedCityName,
      showOnMobile: Boolean(hasProperty || city || zone),
    }

    breadcrumbs.push(newBreadcrumb)
  }

  // Add zone if city with zone
  // FIXME why checking for zone not undefined?? is it something legacy that cannot occur anymore?
  if (zone?.slug && zone?.label && typeof zone !== 'undefined') {
    const newBreadcrumb: Breadcrumb = {
      href: linkBuilder.listingByZone.url(lang, cities, city.slug, zone.slug),
      isLast: !hasProperty,
      isLink: hasProperty,
      label: zone.label,
      showOnMobile: true,
    }

    breadcrumbs.push(newBreadcrumb)
  }

  return breadcrumbs
}
